











import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Patient, Event } from "@/api/model";
import PatientTimelineItem from "./PatientTimelineItem.vue";

@Component({
  components: { PatientTimelineItem }
})
export default class PatientTimeline extends Vue {
  @Prop({
    required: true
  })
  public patient!: Patient;

  @Prop({
    required: true
  })
  public events!: Event[];

  // eventCategory(event: )
}
